/**
 * Load and set up routes and authentication
 */
import Vue from 'vue'

/**
 * Load Bootstrap Vue
 */
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


/**
 * Load and set up form validation
 */

import {
    ValidationObserver,
    ValidationProvider,
    extend,
    localize
} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";

// Configure vee-validate
import { configure } from 'vee-validate';

const config = {
    mode: 'eager'
};
configure(config);

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

extend('landphone', {
    validate: (str) => {
        var pattern = new RegExp('^\\+[0-9]{4,20}$');
        return !!pattern.test(str);
    },
    message: 'This is not a valid phone number. Start with the plus sign then landcode. Don\'t use spaces or dashes.'
});
localize("en", en);

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);


// Install copy to clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);



/**
 * Create a fresh Vue application instance and attach it to the page.
 */

import WhatsAppLinkGenerator from "./WhatsAppLinkGenerator";

const app = new Vue(WhatsAppLinkGenerator).$mount('#app');
